import React, { useCallback, useState } from "react";
import { Page, Card, Tabs } from "@shopify/polaris";

import Pending from "./components/staff/Pending";
import Approved from "./components/staff/Approved";
import Rejected from "./components/staff/Rejected";
import store from "store-js";

export default function Staff() {
  const currentTab = store.get("staffTab") || 0;
  const [selected, setSelected] = useState(currentTab);
  store.set("staffTab", selected);
  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    []
  );

  const tabs = [
    {
      id: "Pending",
      title: "Pending",
      content: "Pending",
      page: <Pending />,
      panelID: "Pending",
    },
    {
      id: "Approved",
      title: "Approved",
      content: "Approved",
      page: <Approved />,
      panelID: "Approved",
    },
    {
      id: "Rejected",
      title: "Rejected",
      content: "Rejected",
      page: <Rejected />,
      panelID: "Rejected",
    },
  ];

  return (
    <Page breadcrumbs={[{ url: "/" }]} title="Staff" fullWidth>
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
          {tabs[selected].page}
        </Tabs>
      </Card>
    </Page>
  );
}
